import { Controller } from "@hotwired/stimulus"

// Handles dismissal of the update notification toast by removing the element from the DOM.
// Future: implement markUpdateAsDismissed() to persist the dismissal. I.e. a fetch call
// to mark as seen server-side, local storage, etc.
export default class extends Controller {
  // The version of the update that was dismissed. In case it's useful.
  // if this goes unused, please remove from here and the component.
  static values = { version: String }

  dismiss() {
    this.markUpdateAsDismissed()
    this.element.remove()
  }

  markUpdateAsDismissed() {
     // TODO: Implement persistence for dismissed updates (e.g., fetch to server or localStorage).
  }
}
